import { Country, auStates, ukStates, usStates } from "./country";

type Verb = {
  past: string;
  present: string;
  future: string;
};

type Term = {
  singular: string;
  plural: string;
  title: string;
  header: string;
  name: string;
};

export type Locale = Readonly<{
  country: Country;
  locale: "en-AU" | "en-US" | "en-GB";
  currency: "AUD" | "USD" | "GBP";
  currencySymbol: "$" | "£";
  dateFormat: ("day" | "month" | "year")[];
  states: { name: string; displayName: string }[];
  terms: {
    digitise: Verb;
    practise: Verb;
    state: Term;
    familyPro: Term;
    enquiry: Term;
    responsiblePerson: Term;
  };
}>;

export const auLocale: Locale = {
  country: "AU",
  locale: "en-AU",
  currency: "AUD",
  currencySymbol: "$",
  states: auStates.map((state) => ({
    name: state.name,
    displayName: state.name,
  })),
  dateFormat: ["day", "month", "year"],
  terms: {
    digitise: {
      past: "digitised",
      present: "digitising",
      future: "digitise",
    },
    practise: {
      past: "practised",
      present: "practising",
      future: "practise",
    },
    state: {
      singular: "a state",
      plural: "states",
      title: "States",
      header: "State",
      name: "state",
    },
    familyPro: {
      singular: "FamilyProperty",
      plural: "FamilyProperty",
      title: "FamilyProperty",
      header: "FamilyProperty",
      name: "FamilyProperty",
    },
    enquiry: {
      singular: "an enquiry",
      plural: "enquiries",
      title: "Enquiry",
      header: "Enquiry",
      name: "enquiry",
    },
    responsiblePerson: {
      singular: "Person Responsible",
      plural: "People Responsible",
      title: "Person Responsible",
      header: "Person Responsible",
      name: "Person Responsible",
    },
  },
};

export const usLocale: Locale = {
  country: "US",
  locale: "en-US",
  currency: "USD",
  currencySymbol: "$",
  states: usStates.map((state) => ({
    name: state.name,
    displayName: state.name,
  })),
  dateFormat: ["month", "day", "year"],
  terms: {
    digitise: {
      past: "digitized",
      present: "digitizing",
      future: "digitize",
    },
    practise: {
      past: "practiced",
      present: "practicing",
      future: "practice",
    },
    state: {
      singular: "a state",
      plural: "states",
      title: "States",
      header: "State",
      name: "state",
    },
    familyPro: {
      singular: "FamilyPro",
      plural: "FamilyPro",
      title: "FamilyPro",
      header: "FamilyPro",
      name: "FamilyPro",
    },
    enquiry: {
      singular: "an inquiry",
      plural: "inquiries",
      title: "Inquiry",
      header: "Inquiry",
      name: "inquiry",
    },
    responsiblePerson: {
      singular: "Attorney Responsible",
      plural: "Attorneys Responsible",
      title: "Attorney Responsible",
      header: "Attorney Responsible",
      name: "Attorney Responsible",
    },
  },
};

export const ukLocale: Locale = {
  country: "GB",
  locale: "en-GB",
  currency: "GBP",
  currencySymbol: "£",
  states: ukStates.map((state) => ({
    name: state.name,
    displayName: state.label,
  })),
  dateFormat: ["day", "month", "year"],
  terms: {
    digitise: {
      past: "digitised",
      present: "digitising",
      future: "digitise",
    },
    practise: {
      past: "practised",
      present: "practising",
      future: "practise",
    },
    state: {
      singular: "a country",
      plural: "countries",
      title: "Countries",
      header: "Country",
      name: "country",
    },
    familyPro: {
      singular: "FamilyProperty",
      plural: "FamilyProperty",
      title: "FamilyProperty",
      header: "FamilyProperty",
      name: "FamilyProperty",
    },
    enquiry: {
      singular: "an enquiry",
      plural: "enquiries",
      title: "Enquiry",
      header: "Enquiry",
      name: "enquiry",
    },
    responsiblePerson: {
      singular: "Fee Earner",
      plural: "Fee Earners",
      title: "Fee Earner",
      header: "Fee Earner",
      name: "Fee Earner",
    },
  },
};
